/**
 * Hooks de media query para la experiencia móvil de las Notas del aseo.
 * Sin `matchMedia` (tests, navegadores muy viejos) responden `false`, o sea
 * "escritorio": la pantalla sigue funcionando.
 */

import { useCallback, useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (cb: () => void) => {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return () => {};
      }
      const mql = window.matchMedia(query);
      // Safari < 14 solo tiene addListener/removeListener.
      if (typeof mql.addEventListener === "function") {
        mql.addEventListener("change", cb);
        return () => mql.removeEventListener("change", cb);
      }
      mql.addListener?.(cb);
      return () => mql.removeListener?.(cb);
    },
    [query],
  );
  const getSnapshot = useCallback(
    () =>
      typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query).matches
        : false,
    [query],
  );
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** Puntero principal "grueso" (dedo): celulares y tablets. En un PC con mouse es false. */
export const useEsTactil = (): boolean => useMediaQuery("(pointer: coarse)");

/** Pantalla de celular: el panel de notas se abre a pantalla completa. */
export const useEsMovil = (): boolean => useMediaQuery("(max-width: 576px)");
